import { GcpTypography } from '@back-office/ui';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import NavigateNext from '@material-ui/icons/NavigateNext';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  () => ({
    link: {
      cursor: 'pointer',
    },
  }),
  { name: 'TransactionBreadcrumbs' }
);

interface TransactionBreadcrumbsProps {
  handleOnClickBreadcrumbs: () => void;
}

const TransactionBreadcrumbs: FC<TransactionBreadcrumbsProps> = (props) => {
  const { handleOnClickBreadcrumbs } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNext fontSize="small" />}
    >
      <GcpTypography paint="hitGray">
        <Link
          className={classes.link}
          color="inherit"
          variant="h3"
          onClick={handleOnClickBreadcrumbs}
        >
          {t('transaction_list.list')}
        </Link>
      </GcpTypography>
      <GcpTypography paint="black">
        <Link color="inherit" variant="h3">
          {t('transaction_list.detail')}
        </Link>
      </GcpTypography>
    </Breadcrumbs>
  );
};

export default TransactionBreadcrumbs;
